/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Text, Pressable } from '@components/atoms'

import { useNavigate } from 'react-router-dom'
import { HomeNavMenuType } from '@redux/types'
import { grey } from '@mui/material/colors'

interface PropsType {
	menu: HomeNavMenuType[]
	selectedIndes: number
}

export const HomeSideNav = (props: PropsType) => {
	// hook
	const navigate = useNavigate()

	return (
		<View css={style}>
			{props.menu.map((aMenu, index) => {
				const isSelected = index === props.selectedIndes
				return (
					<Pressable
						key={aMenu.id}
						className={isSelected ? 'sideMenuButton selected' : 'sideMenuButton'}
						onClick={() => navigate(aMenu.uri)}
					>
						<Text className="sideMenuTitle">{aMenu.title}</Text>
					</Pressable>
				)
			})}
		</View>
	)
}

const style = css({
	width: '15rem',

	'.sideMenuButton': {
		width: '100%',
		padding: '0 1rem',
		color: grey[600],

		'.sideMenuTitle': {
			textAlign: 'left',
		},

		'&.selected': {
			color: grey[900],
		},
	},

	'@media (max-width: 890px)': {
		display: 'none',
		// alignItems: 'center',
		// justifyContent: 'center',
		// width: '100%',
		// height: '2rem',

		// '.sideMenuButton': {
		// 	width: '8rem',
		// 	height: '100%',
		// 	marginLeft: '0.3rem',
		// 	marginRight: '0.3rem',
		// 	border: '1px solid',
		// 	borderRadius: '5px',
		// 	borderColor: grey[500],

		// 	'.sideMenuTitle': {
		// 		textAlign: 'center',
		// 		margin: 0,
		// 	},

		// 	'&.selected': {
		// 		backgroundColor: grey[900],
		// 		borderColor: grey[900],
		// 		color: 'white',
		// 	},
		// },
	},
})
